export enum TaskName {
    CAMPAIGN_ITEM_EXTENSION = "Conflict Items"
}